import React from 'react';
import Form from '../../components/common/Form';
import http from "../../services/httpService";
import toastr from "toastr";
import { getCurrentUserId, getJwt} from "../../services/authService";

class ActivationModal extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: props.email || ""
            },
            errors: {}
        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        }
    }

    doSubmit = async (e) => {
        try {
            const user_id = getCurrentUserId();
            //alert(user_id);
            if(user_id)
            {
                //alert('api/user_activation/');
                //const result = await http.get('api/user-activation/' + user_id, {headers: {authorization: getJwt()}});
                await http.get('api/user-activation/' + user_id, {headers: {authorization: getJwt()}});
                //console.log("doSubmit user_activation result", result);
                //alert("result:", result);
                //if (result)
                //{
                //    toastr.success('result.status '+ result);
                //    //this.props.history.push('/logout');
                //}
                //else
                //{
                //    toastr.error('result.status '+ result);
                //    //this.props.history.push('/logout');
                //}
            }

        }
        catch (ex) {
            //toastr.error(ex);
            if (ex.response && ex.response.status === 404)
            {
                toastr.error("404 (DATA NOT SENT)");
                //this.props.history.push('/logout');
            }

            if (ex.response && ex.response.status === 401)
            {
                //let errors = { ...this.state.errors }
                //console.log(ex.response.data);
                toastr.error(ex.response.data.message);
                //window.location = "/";
                //this.props.history.push('/logout');
            }
            if (ex.response && ex.response.status === 400)
                toastr.error(ex);
        }
        window.location = "/logout";
    };

    render() {
        let {visible_modal, email, onClickAway } = this.props;

        return (
            <div id="activationModal" className="modal" style={visible_modal ? {display: "block"} : {display: "none"}}>
                <div className="modal-content text-center">
                    <h1 className="text-bold m-m-b">You haven't validated your email yet.</h1>
                    <p className="text-bold m-m-b">Please click the validation link sent to your email: <span>{email} </span>.</p>
                    <p className="text-bold m-m-b">Can't find it?</p>
                    <div className="submit-buttons row">
                        <div className="col-md-6">
                            <button disabled={false}
                                    onClick={onClickAway}
                                    name="cancel_activation_email"
                                    id="cancel_activation_email"
                                    type="button"
                                    className="btn-transparent btn-xs"
                                    style={{padding: "1px"}}>Close notice</button>
                        </div>
                        <div className="col-md-6 save-submit">
                            <button disabled={false}
                                    name="activation_email"
                                    id="activation_email"
                                    type="button"
                                    onClick={this.doSubmit}
                                    className='btn-xs btn-action'>Send again
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ActivationModal;